import React from 'react';
import PropTypes from 'prop-types';
import ScrollArea from "react-scrollbar";

const ServiceDisciplines = ({disciplines, scrollable}) => {
    const serviceDisciplines = TB.uniqBy(disciplines || [], 'id');

    // const table = (
    //     <table className="w-full">
    //         <tbody>
    //         {serviceDisciplines.length > 0 && serviceDisciplines.map((discipline, dIndex) => (
    //             <tr key={'discipline' + discipline.id}
    //                 className={"pyo-detail-table-row"}>
    //                 <td>
    //                     <p>
    //                         {dIndex + 1}. {discipline.name}
    //                     </p>
    //
    //                 </td>
    //                 <td>
    //                     <p>
    //                         {discipline.description}
    //                     </p>
    //                 </td>
    //             </tr>
    //         ))}
    //         </tbody>
    //     </table>
    // );

    const table = (
        <div className="w-full flex flex-col divide-y items-stretch">
            {serviceDisciplines.length > 0 && serviceDisciplines.map((discipline, dIndex) => (
                <div key={'discipline' + discipline.id} className="py-5">
                    <div className="border-black border rounded-3xl px-6 h-24 flex flex-row items-center gap-4">
                    <div className="basis-2/5 flex flex-row gap-4 items-center">
                        <i className="fas fa-user text-success text-[26px]"/>
                        <p className="text-sm font-semibold">
                            {discipline.name}
                        </p>
                    </div>
                    <p className="text-xs basis-3/5">
                        {discipline.description}
                    </p>
                </div>
                </div>
            ))}
        </div>
    );

    return (
        <div className="pyo-tab-details py-2">

            <div className="pyo-detail-table">

                {
                    scrollable ? (
                        <ScrollArea
                            speed={0.8}
                            className="area"
                            smoothScrolling={true}
                            contentClassName="scroll-area"
                            stopScrollPropagation={true}
                            horizontal={false}>

                            <div className="mx-3">{table}</div>

                        </ScrollArea>
                    ) : table
                }

            </div>
        </div>
    );
}

ServiceDisciplines.propTypes = {
    disciplines: PropTypes.any,
    scrollable: PropTypes.bool,
};

export default ServiceDisciplines;